"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PtoBalanceCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Button_1 = __importDefault(require("../components/Button"));
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = (isCard) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const isOneColumn = !isCard && columns === 1;
    return react_native_1.StyleSheet.create({
        noCardContainer: {
            marginHorizontal: 0,
            marginTop: isOneColumn ? 0 : (size !== 'sm' ? 12 : 8),
            marginBottom: isOneColumn ? 0 : (size !== 'sm' ? 8 : 4),
        },
        loadingContainer: {
            backgroundColor: isOneColumn ? THEME.CardBackground : 'transparent',
            marginVertical: isOneColumn ? 4 : 0,
            marginHorizontal: isOneColumn ? 0 : 16,
            paddingVertical: isCard ? 12 : 24,
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        },
        balancesContainer: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            margin: isCard ? -6 : 0,
        },
        balanceColumnWrapper: {
            paddingHorizontal: isCard ? 6 : (isOneColumn ? 0 : 16),
            paddingVertical: isCard ? 6 : (isOneColumn ? 0 : 8),
        },
        balanceItemCard: {
            flex: 1,
            borderWidth: isOneColumn ? 0 : 1,
            borderBottomWidth: isOneColumn ? 0 : (isCard ? 1 : 2),
            borderColor: isOneColumn ? 'transparent' : (isCard ? THEME.LightGray : THEME.CardBorder),
            borderRadius: isOneColumn ? 0 : 4,
            backgroundColor: isCard ? THEME.OffWhite : THEME.CardBackground,
            padding: size !== 'sm' ? 14 : 12,
            marginVertical: isOneColumn ? 4 : 0,
        },
        skeletonCard: {
            flex: 1,
            borderWidth: isOneColumn ? 0 : 1,
            borderBottomWidth: isOneColumn ? 0 : (isCard ? 1 : 2),
            borderColor: isOneColumn ? 'transparent' : (isCard ? THEME.LightGray : THEME.CardBorder),
            borderRadius: isOneColumn ? 0 : 4,
            backgroundColor: isCard
                ? (size !== 'sm' ? THEME.UltraLightGray : THEME.SoftGray)
                : THEME.CardBackground,
            padding: size !== 'sm' ? 14 : 12,
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 180,
            marginVertical: isOneColumn ? 4 : 0,
        },
        balanceHeaderRow: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
        },
        balanceTitleContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            flex: 1,
            marginRight: 8,
        },
        balanceName: {
            fontSize: isCard ? (size !== 'sm' ? 17 : 15) : 18,
            fontWeight: isCard ? '600' : '500',
            color: THEME.Text,
            flexShrink: 1,
        },
        requestButton: {
            minWidth: size !== 'sm' ? 92 : 80,
            paddingVertical: 6,
            paddingHorizontal: 12,
        },
        highlightCard: {
            borderWidth: 1,
            borderColor: THEME.LightGray,
            borderRadius: 6,
            backgroundColor: isCard ? THEME.CardBackground : THEME.OffWhite,
            paddingVertical: 10,
            paddingHorizontal: 12,
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 8,
        },
        highlightLabel: {
            fontSize: 11,
            fontWeight: '600',
            color: THEME.TextSecondary,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            marginBottom: 2,
        },
        highlightValue: {
            fontSize: size !== 'sm' ? 28 : 24,
            fontWeight: '700',
            color: THEME.Primary,
        },
        highlightSub: {
            fontSize: 11,
            color: THEME.TextLight,
            marginTop: 2,
        },
        statsGrid: {
            flexDirection: 'row',
            borderWidth: 1,
            borderColor: THEME.LightGray,
            borderRadius: 6,
            backgroundColor: isCard ? THEME.CardBackground : THEME.OffWhite,
            paddingVertical: 8,
            paddingHorizontal: 4,
        },
        statItem: {
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: 4,
            paddingHorizontal: 2,
        },
        statItemBorder: {
            borderRightWidth: 1,
            borderRightColor: THEME.LightGray,
        },
        statLabel: {
            fontSize: size !== 'sm' ? 11 : 10,
            fontWeight: '600',
            color: THEME.TextSecondary,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            marginBottom: 3,
            textAlign: 'center',
        },
        statValue: {
            fontSize: size !== 'sm' ? 15 : 13,
            fontWeight: '600',
            color: THEME.Text,
            textAlign: 'center',
        },
        statUnit: {
            fontSize: 10,
            color: THEME.TextLight,
            marginTop: 1,
            textAlign: 'center',
        },
        emptyContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            marginVertical: 16,
        },
        emptyCard: {
            borderWidth: isOneColumn ? 0 : 1,
            borderBottomWidth: isOneColumn ? 0 : 2,
            borderColor: isOneColumn ? 'transparent' : THEME.CardBorder,
            borderRadius: isOneColumn ? 0 : 4,
            backgroundColor: THEME.CardBackground,
            padding: 24,
            alignItems: 'center',
            justifyContent: 'center',
            marginVertical: isOneColumn ? 4 : 8,
            marginHorizontal: isOneColumn ? 0 : 16,
        },
        emptyText: {
            textAlign: 'center',
            fontSize: size !== 'sm' ? 16 : 14,
            color: THEME.TextNull,
            marginTop: 6,
        },
    });
};
function PtoBalanceCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const approverView = props.approverView ?? false;
    const isCard = props.card !== undefined ? props.card : approverView;
    const styles = useStyles(isCard);
    const [status, setStatus] = react_1.default.useState('loading');
    const [balances, setBalances] = react_1.default.useState(null);
    const [timeAndAttendance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance'));
    const showScheduledPtoFeature = userContext?.client?.features?.find((feature) => feature?.name === 'show-scheduled-pto' || feature?.name === 'show-scheduled_pto');
    const showScheduled = !!showScheduledPtoFeature?.isEnabled;
    const canRequest = !approverView && timeAndAttendance?.isEnabled && !timeAndAttendance?.usesRedirect;
    const isLargest = size === 'lg' || size === 'xl' || columns === 3;
    const isMedium = !isLargest && (size === 'md' || columns === 2);
    const numColumns = approverView ? 1 : (isLargest ? 3 : (isMedium ? 2 : 1));
    const colBasis = numColumns === 3 ? '33.333%' : (numColumns === 2 ? '50%' : '100%');
    const emptyCount = numColumns > 1 && balances && balances.length > 0 && balances.length % numColumns > 0
        ? numColumns - (balances.length % numColumns)
        : 0;
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => TimeAttendance_1.default.getPtoBalances(token, props.employeeId ?? null))).then(data => {
            if (data?.balances && data.balances.length > 0) {
                const enriched = data.balances.map((item) => ({
                    ...item,
                    earned: item.earned ?? item.accrued ?? '0.00',
                    carryover: item.carryover ?? '0.00',
                    taken: item.taken ?? '0.00',
                    scheduled: item.scheduled ?? '0.00',
                    remaining: item.remaining ?? '0.00',
                }));
                setBalances(enriched);
            }
            else {
                setBalances(data?.balances ?? []);
            }
            setStatus('done');
        }).catch(e => {
            setBalances(null);
            setStatus((e == 404) ? 'done' : 'error');
        });
    }, [props.employeeId]);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [refresh]);
    const handleRequest = react_1.default.useCallback((item) => {
        if (!item?.register)
            return;
        if (userContext?.isImpersonated) {
            react_native_1.DeviceEventEmitter.emit('event.showSnackbar', {
                type: 'warning',
                message: t('common:messages.impersonatedUser'),
            });
            return;
        }
        props.navigation?.navigate('PtoRequest', {
            registerName: item?.name,
            register: item?.register,
        });
    }, [props.navigation, t, userContext?.isImpersonated]);
    const content = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [status === 'loading' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.loadingContainer, children: (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: true }) })), status === 'error' && ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, error: true, onRetry: refresh })), status === 'done' && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: balances && balances.length > 0 ? ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.balancesContainer, children: [balances.map((item) => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.balanceColumnWrapper, { flexBasis: colBasis, maxWidth: colBasis }], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [STYLES.notSelectable, styles.balanceItemCard], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.balanceHeaderRow, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.balanceTitleContainer, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.balanceName, numberOfLines: 1, children: item.name }) }), canRequest && ((0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", text: t('time:buttons.request'), textSize: 13, disabled: !item.register || item.enabled === false, onPress: () => handleRequest(item), style: styles.requestButton }))] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.highlightCard, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.highlightLabel, children: t('time:text.currentBalance') }), item.unlimited ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.Infinity, size: size !== 'sm' ? 28 : 24, style: { overflow: 'visible' }, color: THEME.Primary }) })) : ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.highlightValue, children: item.remaining })), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.highlightSub, children: item.unlimited ? t('time:text.discretionaryUse') : t('time:text.hoursRemain') })] }), item.unlimited ? ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statsGrid, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.statItem, showScheduled && styles.statItemBorder], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statLabel, children: t('time:text.taken') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statValue, children: item.taken ?? '0.00' }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statUnit, children: t('time:text.capsHours') })] }), showScheduled && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statLabel, children: t('time:text.scheduledHours') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statValue, children: item.scheduled ?? '0.00' }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statUnit, children: t('time:text.capsHours') })] }))] })) : ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statsGrid, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.statItem, styles.statItemBorder], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statLabel, children: t('time:text.earned') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statValue, children: item.earned ?? item.accrued ?? '0.00' }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statUnit, children: t('time:text.capsHours') })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.statItem, styles.statItemBorder], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statLabel, children: `+ ${t('time:text.carryover')}` }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statValue, children: item.carryover ?? '0.00' }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statUnit, children: t('time:text.capsHours') })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.statItem, showScheduled && styles.statItemBorder], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statLabel, children: `− ${t('time:text.taken')}` }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statValue, children: item.taken ?? '0.00' }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statUnit, children: t('time:text.capsHours') })] }), showScheduled && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statLabel, children: t('time:text.scheduledHours') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statValue, children: item.scheduled ?? '0.00' }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.statUnit, children: t('time:text.capsHours') })] }))] }))] }) }, item.name))), emptyCount > 0 &&
                                [...Array(emptyCount)].map((_, index) => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.balanceColumnWrapper, { flexBasis: colBasis, maxWidth: colBasis }], children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.skeletonCard, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.AlarmClock, size: 36, color: THEME.TextDisabled }) }) }, 'pto-skeleton-' + index)))] }) })) : ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: isCard ? styles.emptyContainer : styles.emptyCard, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CalendarCircleExclamation, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.emptyText, children: t('time:text.noPTO') })] })) }))] }));
    if (isCard) {
        return ((0, jsx_runtime_1.jsxs)(Card_1.default, { style: { paddingBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('time:headers.balances'), style: { marginBottom: 8 } }), content] }));
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.noCardContainer, children: content }));
}
